// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"616":"837c7cf9","632":"4ab4acd0"}[chunkId] + ".chunk.js";
};